import {
    GET_VERSION
} from "../../constant/reducerConstants";

const initialState = {
    version: ""
};

export function appReducer(state = initialState, action) {
    switch (action.type) {
        case GET_VERSION:
            return {...state, version: action.data.version};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/reducer/appReducer.js